import { render } from "./SertifikasiBudidayaIkan.vue?vue&type=template&id=16d362b9"
import script from "./SertifikasiBudidayaIkan.vue?vue&type=script&lang=js"
export * from "./SertifikasiBudidayaIkan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__